import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import { HttpClient } from '@angular/common/http';
import { Personal } from '../../models/Personal/Personal';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { InfoPersonalCompanyPersonalId } from '../../models/Personal/InfoPersonalCompanyPersonalId';
import { ModelSaveCarnetPrint, ModelSaveCarnetPrintResponse, Poll, ExtractedDocumentResponse } from '../../interfaces/interfaces';
import { PersonalInfoContract } from '../../models/Personal/personalInfoContract';
import { ContractsOffline } from '../../models/Personal/ContractsOffline';
import { FacePhoto, FaceTraceResponse } from '../../models/Personal/FaceTrace';
@Injectable({
  providedIn: 'root'
})
export class PersonalService {

    constructor(
        private api: ApiService,
        // tslint:disable-next-line:variable-name
        private _http: HttpClient
    ) { }

    /**
     * Permite traer el personal witch adminInfoId
     */
    getPersonalFilterAdminInfoId(adminInfoId, page?, pageWindow?, filter?, Search?) {
      return this._http.get<any>(
        this.api.getUrl(
          `api/Personal?${adminInfoId !== undefined ? `adminInfoId=${adminInfoId}&` : ``}v2=true` +
          `${page !== undefined ? `&page=${page}` : `&page=1`}` +
          `${pageWindow !== undefined ? `&pageWindow=${pageWindow}` : `&pageWindow=32`}` +
          `${filter !== undefined && filter !== null ? `&filter=${filter}` : `&filter=`}` +
          `${Search !== undefined && Search !== null ? `&search=${Search}` : ``}`
        )
      );
    }

    // GET:ID Personal
    // getPersonalId(id): Observable<Personal>{
    //     return this._http.get<Personal>(this.api.getUrl('api/Personal/' + id + '?v2=true'));
    // }
    getPersonalId(id, request = false): Observable<Personal>{
      let url = `api/Personal/${id}?v2=true`;
      if (request) {
        url += '&request=true';
      }
      return this._http.get<Personal>(this.api.getUrl(url));
    }

    putPersonalFull(id, model) {
        return this._http.put(this.api.getUrl(`api/Personal/UpdatePersonalFull/${id}`), model);
    }

    getPersonalDocNumContractId(docNum, contractId) {
        return this._http.get(this.api.getUrl(`api/Personal/GetId/${docNum}/${contractId}`));
    }

    postPersonalInfoCompany(model) {
        return this._http.post(this.api.getUrl(`api/Personal/InfoCompany`), model);
    }

    postContractPersonalInfo(id, model, tillEndOfDay?) {
        return this._http.post(this.api.getUrl(`api/Contract/${id}/PersonalInfo?${tillEndOfDay
        !== undefined ? 'tillEndOfDay=false' : ''}`) + '&v2=true',  model);
    }

    getContractsOfflinePersonalCompanyInfoId(personalCompanyInfoId, onlyActive = false): Observable<ContractsOffline[]> {
        return this._http.get<ContractsOffline[]>(this.api.getUrl(`api/Personal/ContractsOffline?full=true&personalCompanyInfoId=${personalCompanyInfoId}` + '&v4=true' + '&onlyActive=' + onlyActive));
    }

    getInfoPersonalCompanyPersonalId(personalCompanyInfoId, request = false): Observable<InfoPersonalCompanyPersonalId> {
      let url = `api/Personal/GetInfoPersonalCompany?PersonalId=${personalCompanyInfoId}&v3=true`;
      if (request) {
        url += '&request=true';
      }
      return this._http.get<InfoPersonalCompanyPersonalId>(this.api.getUrl(url));
    }

    // Save Print Carnet POST
    printSaveCarnet(printCarnet: ModelSaveCarnetPrint): Observable<ModelSaveCarnetPrintResponse> {
        return this._http.post<ModelSaveCarnetPrintResponse>(this.api.getUrl('api/Carnet'), printCarnet);
    }

    // Save Print Carnet PATCH
    printSaveCarnetPATCH(idCarnet: number) {
        return this._http.patch(this.api.getUrl(`api/Carnet/${idCarnet}`),  [{op: 'replace', path: '/IsActive', value: 'false'}]);
    }

    changeEpsAFpPATCH(id, path, value) {
        return this._http.patch(this.api.getUrl(`api/Person/${id}`),  [{op: 'replace', path, value}]);
    }

    // get PersonalsInfo Contract
    getPersonalsInfoContract(contractId): Observable<PersonalInfoContract[]> {
        return this._http.get<PersonalInfoContract[]>(this.api.getUrl(`api/Contract/${contractId}/PersonalInfo`));
    }

    // get PersonalsInfo Contract
    updatePersonalsInfoContract(contractId, PersonalInfo, personalInfo: PersonalInfoContract) {
        return this._http.post(this.api.getUrl(`api/Contract/${contractId}/PersonalInfo?Id=${PersonalInfo}`), personalInfo);
    }

    // putPersonal con el document
    putUpdatePersonal(personalModel) {
        return this._http.put(this.api.getUrl(`api/Personal/UpdatePersonal`), personalModel);
    }

    updatePhotoCompanyInfo(id, file) {
        return this._http.put(this.api.getUrl(`api/Personal/CompanyInfo/UpdatePhoto/${id}`), file);
    }

    putEmployerPersonalRequirement(Id, model) {
        return this._http.put(this.api.getUrl(`api/EmployerPersonalRequirement/${Id}`), model);
    }

    putPersonalRequirement(Id, model) {
        return this._http.put(this.api.getUrl(`api/PersonalRequirement/${Id}`), model);
    }

    putDELETEPersonalRequirement(Id, model) {
        return this._http.put(this.api.getUrl(`api/PersonalRequirement/DeleteFiles/${Id}`), model);
    }

    putUPDATEFILEPersonalRequirement(Id, file, durationOptionId?, baseDate?) {
      const rawFecha = (baseDate !== undefined && baseDate !== null && baseDate !== '') ? baseDate : '';
      const fecha = rawFecha ? encodeURIComponent(String(rawFecha)) : '';

      let url = `api/PersonalRequirement/UpdateFile/${Id}?baseDate=${fecha}`;
      if (durationOptionId != null && durationOptionId !== '') {
        url += `&durationOptionId=${durationOptionId}`;
      }
      return this._http.put(this.api.getUrl(url), file);
    }

    putUPDATEFILEEmployerPersonalRequirement(Id, file, durationOptionId?, baseDate?) {
      const rawFecha = (baseDate !== undefined && baseDate !== null && baseDate !== '') ? baseDate : '';
      const fecha = rawFecha ? encodeURIComponent(String(rawFecha)) : '';

      let url = `api/EmployerPersonalRequirement/UpdateFile/${Id}?baseDate=${fecha}`;
      if (durationOptionId != null && durationOptionId !== '') {
        url += `&durationOptionId=${durationOptionId}`;
      }
      return this._http.put(this.api.getUrl(url), file);
    }

    putDELETEEmployerPersonalRequirement(Id, model) {
        return this._http.put(this.api.getUrl(`api/EmployerPersonalRequirement/DeleteFiles/${Id}`), model);
    }

    putUPDATEFILEEmployerPersonalRequirementPlanilla(requirementId, personalCompanyInfoId, employerInfoId, file) {
        return this._http.put(this.api.getUrl(`api/Requirement/UpdateDocument/${requirementId}?personalCompanyInfoId=${personalCompanyInfoId}&employerInfoId=${employerInfoId}`), file);
    }

    putPersonalRequirementPlanilla(requirementId, personalCompanyInfoId, employerInfoId, date) {
        return this._http.put(this.api.getUrl(`api/Requirement/UpdateDocument/${requirementId}?personalCompanyInfoId=${personalCompanyInfoId}&employerInfoId=${employerInfoId}&date=${date}`), null);
    }

    // PersonalCV
    postPersonalCV(model) {
        return this._http.post(this.api.getUrl(`api/PersonalCV`), model);
    }

    getPersonalCV(PersonalInfoId) {
        return this._http.get(this.api.getUrl(`api/PersonalCV/${PersonalInfoId}`));
    }

    updatePhotoAddStudyCertificate(personalCVId, file) {
        return this._http.put(this.api.getUrl(`api/PersonalCV/AddStudyCertificate/${personalCVId}`), file);
    }

    updatePhotoAddExperienceCertificate(personalCVId, file) {
        return this._http.put(this.api.getUrl(`api/PersonalCV/AddExperienceCertificate/${personalCVId}`), file);
    }
    // PersonalCVk FIN

    /**
     * Permite obtener el personal vinculados al contrato por id del contrato o personalInfoId
     */
    getContractPersonalInfoId(id, personalInfoId) {
        return this._http.get(this.api.getUrl(`api/Contract/${id}/PersonalInfo?personalInfoId=${personalInfoId}`));
    }
    /**
     * Permite actualizar el personal vinculados al contrato por id del contrato o personalInfoId
     */
    postContractPersonalInfoId(ContractId, Id, model) {
        return this._http.post(this.api.getUrl(`api/Contract/${ContractId}/PersonalInfo?Id=${Id}`), model);
    }

    getVaccine(personalCompanyInfoId) {
        return this._http.get(this.api.getUrl(`api/Personal/Vaccine/${personalCompanyInfoId}`));
    }

    postVaccine(model) {
      // tslint:disable-next-line:radix
        model.PersonalCompanyInfoId = parseInt(model.PersonalCompanyInfoId);
        return this._http.post(this.api.getUrl(`api/Personal/Vaccine`), model);
    }

    postTransferDocumentRequirement(model) {
        model.personalCompanyInfo = parseInt(model.personalCompanyInfo);
        return this._http.post(this.api.getUrl(`api/Requirement/DocumentRequirement/Transfer`), model);
    }

    postTransferDocumentRequirementWithPersonalEmployer(model) {
        model.personalCompanyInfo = parseInt(model.personalCompanyInfo);
        return this._http.post(this.api.getUrl(`api/Requirement/DocumentRequirement/TransferWithPersonalEmployer`), model);
    }

    getPersonalContracts(personalCompanyInfoId) {
        return this._http.get(this.api.getUrl(`api/Personal/${personalCompanyInfoId}/Contracts`));
    }

    // Nuevas apis conteratos
    getPersonalEmployerByPersonal(personalCompanyInfoId, onlyActive = false, request = null) {
      let url = `api/PersonalEmployer/ByPersonal/${personalCompanyInfoId}` + '?onlyActive=' + onlyActive;

      if (request != null && request !== '') {
        url += `&request=${request}`;
      }
      return this._http.get(this.api.getUrl(url));
    }

    getWorkplaceHistory(personalCompanyInfoId: number | string, employerInfoId: string) {
      return this._http.get(this.api.getUrl(`api/PersonalEmployer/WorkplaceHistory/${personalCompanyInfoId}/${employerInfoId}`));
    }

    putWorkplaceHistory(personalEmployerId: number | string, workplaceId: number | string, data: any, adjustWorkShift: boolean = false) {
        return this._http.put(this.api.getUrl(`api/PersonalEmployer/${personalEmployerId}/WorkplaceHistory/${workplaceId}?adjustWorkShift=${adjustWorkShift}`), data);
    }

    // Post
    postPersonalEmployer(model) {
        return this._http.post(this.api.getUrl(`api/PersonalEmployer`), model);
    }

    // pu
    putPersonalEmployer(personalEmployerId, model) {
        return this._http.put(this.api.getUrl(`api/PersonalEmployer/${personalEmployerId}`), model);
    }
    putPersonalEmployerSnapshot(personalEmployerId, model) {
      return this._http.put(this.api.getUrl(`api/PersonalEmployer/Snapshot/${personalEmployerId}`), model);
    }

    // pu
    deletePersonalEmployer(personalEmployerId) {
        return this._http.delete(this.api.getUrl(`api/PersonalEmployer/${personalEmployerId}`));
    }

    // exist contract?
    // getPersonalEmployerByPersonalAndEmployer(personalCompanyInfoId, employerInfoId) {
    //     return this._http.get(this.api.getUrl(`api/PersonalEmployer/ByPersonalAndEmployer/${personalCompanyInfoId}/${employerInfoId}`));
    // }
    getPersonalEmployerByPersonalAndEmployer(
      personalCompanyInfoId: string,
      employerInfoId: string,
      fromRequestId: boolean = false
    ): Observable<any> {

      // Build the base URL
      let url = this.api.getUrl(`api/PersonalEmployer/ByPersonalAndEmployer/${personalCompanyInfoId}/${employerInfoId}`);

      // NEW: Add query parameter if fromRequestId is true
      if (fromRequestId) {
        url += '?request=true';
      }

      return this._http.get(url);
    }

    // exist contract?
    getPersonalEmployerGenerateContractNumber() {
        return this._http.get(this.api.getUrl(`api/PersonalEmployer/GenerateContractNumber`));
    }

    getPersonalWorkShiftrprojectId(projectId) {
        return this._http.get(this.api.getUrl(`api/WorkShift/Project/${projectId}`));
    }

    getCountDocumentInfoPersonal(id) {
        return this._http.get<any>(this.api.getUrl(`api/DocumentInfo/Personal/Count/${id}`));
    }

    /**
     * Permite actualizar el comentario sin archivo
     * @param comment
     */
    putPersonalRequirementUpdateComment(id, comment, durationOptionId?, baseDate?) {
      const rawFecha = (baseDate !== undefined && baseDate !== null && baseDate !== '') ? baseDate : '';
      const fecha = rawFecha ? encodeURIComponent(String(rawFecha)) : '';

      let url = `api/PersonalRequirement/UpdateComment/${id}?comment=${comment ? `&comment=${comment}` : ''}&baseDate=${fecha}`;

      if (durationOptionId != null && durationOptionId !== '') {
        url += `&durationOptionId=${durationOptionId}`;
      }
      return this._http.put(this.api.getUrl(url), null);
    }

  /**
     * Permite actualizar el comentario sin archivo
     * @param comment
     */
    putEmployerPersonalRequirementUpdateComment(id, comment, durationOptionId?, baseDate?) {
    const rawFecha = (baseDate !== undefined && baseDate !== null && baseDate !== '') ? baseDate : '';
    const fecha = rawFecha ? encodeURIComponent(String(rawFecha)) : '';
    let url = `api/EmployerPersonalRequirement/UpdateComment/${id}?comment=${comment ? `&comment=${comment}` : ''}&baseDate=${fecha}`;

    if (durationOptionId != null && durationOptionId !== '') {
      url += `&durationOptionId=${durationOptionId}`;
    }
    return this._http.put(this.api.getUrl(url), null);

    }

    getSocialSecurityPersonalUnlimited(EmployerInfoId, documentNumber) {
        return this._http.get(this.api.getUrl(`api/SocialSecurity/PersonalUnlimited/${EmployerInfoId}?documentNumber=${documentNumber}`));
    }

    putExtractFromDocument(compnayInfoId: string, file) {
        return this._http.put(this.api.getUrl(`api/Personal/ExtracFromDoc/${compnayInfoId}`), file);
    }

    getExtractFromDocument(compnayInfoId: string) {
        return this._http.get(this.api.getUrl(`api/Personal/DatasheetExtraction/${compnayInfoId}`));
    }

    /**
     * Extrae los datos de una cédula (PDF/foto) usando IA para pre-llenar el formulario de creación de personal.
     */
    extractPersonalDocument(file: File, proyectoId?: string, empresaId?: string): Observable<ExtractedDocumentResponse> {
        const formData = new FormData();
        formData.append('file', file);
        if (proyectoId) {
            formData.append('proyectoId', proyectoId);
        }
        if (empresaId) {
            formData.append('empresaId', empresaId);
        }
        return this._http.post<ExtractedDocumentResponse>(
            this.api.getUrl('api/document-extraction/extract'), formData
        ).pipe(timeout(60000));
    }

    getMassUploadProcessId(massUploadId?) {
       return this._http.get(this.api.getUrl(`api/MassUpload/History/${massUploadId}`));
    }

    getMassUploadType() {
        return this._http.get(this.api.getUrl(`api/MassUpload/Type`));
    }

    postProcess(massUploadId?) {
        return this._http.post(this.api.getUrl(`api/MassUpload/Process/${massUploadId}`), {});
    }

    getMassUploadInfo(typeId) {
        return this._http.get(this.api.getUrl(`api/MassUpload/Info/${typeId}`));
    }

    putMassUploadInfoFile(massUploadId: string, file) {
        return this._http.put(this.api.getUrl(`api/MassUpload/UploadInfoFile/${massUploadId}`), file);
    }

    putMassUploadPayloadFile(massUploadId: string, file) {
        return this._http.put(this.api.getUrl(`api/MassUpload/UploadPayloadFile/${massUploadId}`), file);
    }

    postMassUploadInit(body) {
      return this._http.post(this.api.getUrl(`api/MassUpload/Init`), body);
    }

    getEmployerSelect(full: boolean = false) {
      const url = full ? `api/Employer/Select?full=true` : `api/Employer/Select`;
      return this._http.get(this.api.getUrl(url));
    }

    // CAPACITACIONES CON EXAMEN
    getTrainingWithExam(id, employerInfoId) {
        return this._http.get(this.api.getUrl(`api/Training/Personal/${id}/Evaluations?employerInfoId=${employerInfoId}`));
    }

    getTrainingEvaluations(evaluationId){
      return this._http.get(this.api.getUrl(`api/Training/Evaluations/${evaluationId}/Summary`));
    }

    getTypeOfWithdrawals(companyInfoId: string) {
      return this._http.get(this.api.getUrl(`api/PersonalTerminationRequest/TerminationType?companyInfoId=${companyInfoId}`));
    }

    postMassUploadCreateTerminations(model) {
      return this._http.post(this.api.getUrl(`api/MassUpload/CreateTerminations`), model);
    }

    getMassUploadInfoInt(typeId) {
      return this._http.get(this.api.getUrl(`api/MassUpload/Info/${typeId}`));
    }

    getFacePhotos(personalCompanyInfoId: string | number, includeDeleted: boolean = true): Observable<FacePhoto[]> {
      return this._http.get<FacePhoto[]>(this.api.getUrl(`api/Personal/CompanyInfo/FacePhotos/${personalCompanyInfoId}?includeDeleted=${includeDeleted}`));
    }

    getFaceTrace(personalCompanyInfoId: string | number, page: number = 1, pageSize: number = 50, personalPhotoId?: number): Observable<FaceTraceResponse> {
      let url = `api/Personal/CompanyInfo/FaceTrace/${personalCompanyInfoId}?page=${page}&pageSize=${pageSize}`;
      if (personalPhotoId) {
        url += `&personalPhotoId=${personalPhotoId}`;
      }
      return this._http.get<FaceTraceResponse>(this.api.getUrl(url));
    }

    deleteFacePhoto(personalPhotoId: number): Observable<any> {
      return this._http.delete(this.api.getUrl(`api/Personal/CompanyInfo/FacePhotos/${personalPhotoId}`));
    }

    reprocessPhoto(personalCompanyInfoId: string | number): Observable<any> {
      return this._http.post(this.api.getUrl(`api/Personal/CompanyInfo/ReprocessPhoto/${personalCompanyInfoId}`), {});
    }

    getFaceSummary(personalCompanyInfoId: string | number, personalPhotoId?: number): Observable<any> {
      let url = `api/Personal/CompanyInfo/FaceSummary/${personalCompanyInfoId}`;
      if (personalPhotoId) {
        url += `?personalPhotoId=${personalPhotoId}`;
      }
      return this._http.get<any>(this.api.getUrl(url));
    }

    getFaceValidation(personalCompanyInfoId: string | number, personalPhotoId?: number): Observable<any> {
      let url = `api/Personal/CompanyInfo/FaceValidation/${personalCompanyInfoId}`;
      if (personalPhotoId) {
        url += `?personalPhotoId=${personalPhotoId}`;
      }
      return this._http.get<any>(this.api.getUrl(url));
    }

    putSaveRequestPhotoChange(personalCompanyInfoId: string | number, body: { RequestPhotoChange: boolean }): Observable<any> {
      return this._http.put<any>(this.api.getUrl(`api/Personal/RequestPhotoChange/${personalCompanyInfoId}`), body);
    }
}

